<template>
	<div class="page-main">
		<div class="main-head">
			<div class="breakcrumbs">联盟院校  >  机构主页</div>
			<!-- <div class="back-btn">返回</div> -->
		</div>
		

			<!-- 院校信息 -->
			<div class="teacher-box" v-if="detail">
				<div class="pic">
					<img class="logo" :src="detail.orgLogo" alt="">
				</div>
				<div class="info">
					<h3 class="name">{{detail.orgName}}</h3>
					<div class="des">{{detail.introduction}}</div>
				</div>
			</div>
			
			<!-- 课程 -->
			<div class="course-wrap">
				<div class="tag-box">
					<span :class="{act:index==tagIndex}" v-for="(item,index) in tagList" :key="index"
						@click="changeTag(index)">{{item}}</span>
				</div>
				
				<!-- 课程资源列表 -->
				<div class="course-box" v-show="tagIndex==0">
					<ul class="course-list">
						<li v-for="(item,index) in courseInfo.list" :key="item.courseId" @click="goCourseDetail(item)" >
							<div v-if="item.courseLevelName" class="label" :class="item.courseLevelClass">{{item.courseLevelName}}</div>
							<img class="img" :src="item.courseImg || dfImg" alt="">
							<div class="info">
								<h3>{{item.courseName}}</h3>
								<div class="center">
									<p>{{item.orgName}} | {{item.teacherName}}</p>
								</div>
							</div>
							<div class="btm">
								<span class="term" :class="{gray:item.offerCoursesStu==3}" v-if="item.termName && item.offerCoursesStu!=4">{{item.termName}}</span>
								<span class="status" :class="item.offerCoursesClass">{{item.offerCoursesName}}</span>
								<span class="learn-num">{{item.allChooseCount || 0}}</span>
							</div>
						</li>
					</ul>
					<!-- 分页 -->
					<div class="paging" v-if="courseInfo.pagingList.length>1">
						<span class="prev" @click="changePaging(courseInfo.pageNum-1,'courseInfo')"><img src="../../static/img/ico-tri.png" alt=""></span>
						<span :class="{active:index==courseInfo.pageNum-1}" v-for="(item,index) in courseInfo.pagingList" :key="index" 
							@click="changePaging(item,'courseInfo')">{{item}}</span>
						<span class="next" @click="changePaging(courseInfo.pageNum+1,'courseInfo')"><img src="../../static/img/ico-tri.png" alt=""></span>
					</div>
				</div>
				
				<!-- 教师团队列表 -->
				<div class="teacher-wrap" v-show="tagIndex==1">
					<div class="teacher-list">
						<div class="teacher-item" v-for="(item,index) in teacherInfo.list" :key="item.teacherId">
							<div class="box">
								<div class="pic" :class="{df:!item.headImage}" >
									<img v-if="!item.headImage" src="../../static/img/common/per-img2.png" alt="">
									<img class="per" v-if="item.headImage" :src="item.headImage" alt="">
								</div>
								<div class="info">
									<h3 class="name">{{item.teacherName}}</h3>
									<div class="label">{{item.orgName}}    {{item.title}}</div>
									<div class="des">{{item.introduction}}</div>
								<!-- 	<a class="more" href="javascript:;" @click="goTeacherDetail(item)">主持建设课程{{item.lecturerCounts || 0}}门  |  参与建设课程{{item.buildCounts || 0}}门</a> -->
								</div>
							</div>
							<ul class="course-list">
								<li v-for="(item2,index2) in item.courseList" :key="item2.courseId" @click="goCourseDetail(item2)" v-show="index2<2">
									<div v-if="item2.courseLevelName" class="label" :class="item2.courseLevelClass">{{item2.courseLevelName}}</div>
									<img class="img" :src="item2.courseImg || dfImg" alt="">
									<div class="info">
										<h3>{{item2.courseName}}</h3>
										<div class="center">
											<p>{{item2.orgName}} | {{item2.teacherName}}</p>
										</div>
									</div>
									<div class="btm">
										<span class="term" :class="{gray:item.offerCoursesStu==3}" v-if="item.termName && item.offerCoursesStu!=4">{{item.termName}}</span>
										<span class="status" :class="item2.offerCoursesClass">{{item2.offerCoursesName}}</span>
										<span class="learn-num">{{item2.allChooseCount || 0}}人已学</span>
									</div>
								</li>
							</ul>
							<img v-if="item.courseList.length>2" class="more-btn" src="../../static/img/more-btn.png" alt=""
								@click="goTeacherDetail(item)">
						</div>
					</div>
					<!-- 分页 -->
					<div class="paging" v-if="teacherInfo.pagingList.length>1">
						<span class="prev" @click="changePaging(teacherInfo.pageNum-1,'teacherInfo')"><img src="../../static/img/ico-tri.png" alt=""></span>
						<span :class="{active:index==teacherInfo.pageNum-1}" v-for="(item,index) in teacherInfo.pagingList" :key="index" 
							@click="changePaging(item,'teacherInfo')">{{item}}</span>
						<span class="next" @click="changePaging(teacherInfo.pageNum+1,'teacherInfo')"><img src="../../static/img/ico-tri.png" alt=""></span>
					</div>
				</div>
				
			</div>
			
		
		<!-- 通用底部 -->
		<!-- <m-footer></m-footer> -->
	</div>
</template>

<script>

	let courseArr = [
    {
        "courseMajorLevel": 1,
        "offerCoursesStu": 3,
        "orgName": "新余学院",
        "teacherName": "郭向荣",
        "orgId": "6437334744597266435",
        "termId": "6428977391074279440",
        "isCurrentTerm": 1,
        "courseName": "思想道德与法制",
        "courseSubject": "法学",
        "createdDt": "2022-05-16T19:06:22",
        "teacherId": "6488631634957435012",
        "courseLevel": 0,
        "courseImg": "http://jx-edu.oss-cn-shenzhen.aliyuncs.com/datafile/public/20220516194856988c34445b9f05ccd576504c91.png",
        "startTime": "2022-03-01",
        "endTime": "2022-06-30",
        "allChooseCount": "0",
        "termName": "2022春",
        "courseId": "6488631634957435013",
		offerCoursesName:'已结课',
		offerCoursesClass:'gray'
    },
    {
        "courseMajorLevel": 1,
        "offerCoursesStu": 3,
        "orgName": "江西理工大学",
        "teacherName": "张明",
        "orgId": "6437334744597266434",
        "termId": "6428977391074279440",
        "isCurrentTerm": 1,
        "courseName": "知识产权法",
        "courseSubject": "法学",
        "createdDt": "2022-05-14T10:16:04",
        "teacherId": "6485814686167072771",
        "courseLevel": 0,
        "courseImg": "http://jx-edu.oss-cn-shenzhen.aliyuncs.com/datafile/public/20220514dfcb94c36aae4712892df13e222bf126.png",
        "startTime": "2022-03-01",
        "endTime": "2022-06-30",
        "allChooseCount": "0",
        "termName": "2022春",
        "courseId": "6485814686167072772",
		offerCoursesName:'已结课',
		offerCoursesClass:'gray'
    },
    {
        "courseMajorLevel": 1,
        "offerCoursesStu": 3,
        "orgName": "赣南医学院",
        "teacherName": "林如丹",
        "orgId": "6437334744597266433",
        "termId": "6428977391074279440",
        "isCurrentTerm": 1,
        "courseName": "C语言程序设计",
        "courseSubject": "工学",
        "createdDt": "2022-05-13T15:10:06",
        "teacherId": "6485097873305239570",
        "courseLevel": 0,
        "courseImg": "http://jx-edu.oss-cn-shenzhen.aliyuncs.com/datafile/public/20220513749830c539d042109643e551784da11c.jpg",
        "startTime": "2022-03-01",
        "endTime": "2022-06-30",
        "allChooseCount": "0",
        "termName": "2022春",
        "courseId": "6485097873305239571",
		offerCoursesName:'已结课',
		offerCoursesClass:'gray'
    }
    
]
export default {
	data () {
		return {
			tagList:[ '开放课程','教师团队' ],
			tagIndex:0,
			
			detail:null,	//院校详情
			orgId:'',		//院校id
			courseInfo:{	//开放课程
				list:[],
				pageNum:1,
				pageSize:8,
				total:0,
				pagingList:[],
			},
			teacherInfo:{	//教师团队
				list:[],
				pageNum:1,
				pageSize:5,
				total:0,
				pagingList:[],
			}
		}
	},
	
	async created(){
		await this.$onLaunched;		//监听加载了APP.vue中的onLaunched的异步后执行
		this.schoolsId = this.$route.params.id
		this.getDetail()
		this.getOpenCourse()
		this.getTeacher()
	},
  
	computed:{
		
	},
  
	methods:{
		changeTag(index){
			this.tagIndex = index 
		},
		
		//获取院校详情
		getDetail(){
			const { schoolsId } =this
			this.$axios({
				url:`/jxedu/api/site/findPartnersOrgDetail/${schoolsId}`,
			}).then(res=>{
				let detail = res.data
				this.detail = detail
			})
		},
		
		//获取院校开放课程列表
		getOpenCourse(){
			const { schoolsId } =this
			const { pageSize, pageNum } = this.courseInfo
			this.$axios({
				url:`/jxedu/api/site/findOpenCourse`,
				params:{
					schoolsId,
					pageNum,
					pageSize
				}
			}).then(res=>{
				let list = res.rows
				let total = res.total
				list.forEach(item=>{
					switch(item.courseLevel){	//课程级别：0普通网课 1联盟精品课 2国家精品课 3省级精品课
						case 0: item.courseLevelName = ''; item.courseLevelClass = ''; break;
						case 1: item.courseLevelName = '省级精品'; item.courseLevelClass = 'blue'; break;
						case 2: item.courseLevelName = '国家精品'; item.courseLevelClass = 'orange'; break;
						case 3: item.courseLevelName = '省级线上一流'; item.courseLevelClass = 'green'; break;
						case 4: item.courseLevelName = '国家线上一流'; item.courseLevelClass = 'red'; break;
					}
					switch(item.offerCoursesStu){	//开课状态：0:全部，1:即将开课,2:开课中,3:已结课,4:暂未开课
						case 1: item.offerCoursesName = '即将开课'; item.offerCoursesClass = 'orange'; break;
						case 2: item.offerCoursesName = '开课中'; item.offerCoursesClass = 'blue'; break;
						case 3: item.offerCoursesName = '已结课'; item.offerCoursesClass = 'gray'; break;
						case 4: item.offerCoursesName = '暂未开课'; item.offerCoursesClass = 'gray'; break;
					}
				})
				
				let num = Math.ceil(total/pageSize)
				let pagingList = []
				if(num>0){
					for(var i=0; i<num; i++){
						pagingList.push(i+1)
					}
				}else{
					pagingList.push(1)
				}
				
				this.courseInfo.list = list
				this.courseInfo.total = total
				this.courseInfo.pagingList = pagingList
			})
		},
		
		//获取教师团队
		getTeacher(){
			const { schoolsId } =this
			const { pageSize, pageNum } = this.teacherInfo
			this.$axios({
				url:`/jxedu/api/site/findTeacherTeam`,
				params:{
					schoolsId,
					pageNum,
					pageSize
				}
			}).then(res=>{
				let list = res.rows
				
				list.forEach(item=>{
					item.courseList = courseArr
				})
				
				let num = Math.ceil(res.total/pageSize)
				let pagingList = []
				if(num>0){
					for(var i=0; i<num; i++){
						pagingList.push(i+1)
					}
				}else{
					pagingList.push(1)
				}
				
				this.teacherInfo.list = list
				this.teacherInfo.total = res.total
				this.teacherInfo.pagingList = pagingList
			})
		},
		
		//切换分页
		changePaging(num,obj){
			const { pageNum, pagingList } = this[obj]
			if(num < 1 || num > pagingList.length || pageNum == num){
				return
			}
			this[obj].pageNum = num
			switch(obj){
				case 'courseInfo':  //开放课堂
					this.getOpenCourse();
					break;
				case 'teacherInfo':  //开放课堂
					this.getTeacher();
					break;	
			}
		},
		
		goTeacherDetail(item){
			this.goUrl({name:'teacherDetail',params:{ id:item.teacherId }, query:{ schoolsId : this.schoolsId}})
		}
	}
}
</script>

<style lang="less" scoped>
@import '~@/static/css/pc-course.less';
.page-mdl{
	//background:url('../../static/img/college-bg.png') no-repeat center top; background-size:1920px auto;
}
.teacher-box{
	box-sizing: border-box; padding:40px 100px 0 38px; display:flex;
	.pic{ 
		width:280px; height:280px; background: #FFFFFF; box-shadow: 0px 0px 18px 0px rgba(41,134,230,0.1500); 
		border-radius: 20px; margin-right:34px; padding:30px; box-sizing: border-box;
		img{ width:220px; }
	}
	.info{
		flex:1; padding-top:10px;
		.name{ font-size:20px; color:#131F33; font-weight: bold; line-height:20px; margin-bottom:12px; }
		.label{ font-size: 14px; line-height:16px; color:#999999; margin-bottom:12px;}
		.des{ 
			font-size: 16px; line-height:26px; color:#131F33;  margin-bottom:70px;
		}
	}
}

.course-wrap{ 
	padding:30px 22px 0; 
	.course-box .course-list li{ 
		margin-right:12px;
		&:child-nth(4n+4){ margin-right:0; }
	}
}
.teacher-list{
	display:flex; justify-content: space-between; flex-wrap: wrap;
	.teacher-item{
		display:flex; margin-bottom:20px; width:100%; height:290px; box-sizing: border-box; position:relative;
		background: url(../../static/img/teacher-bg.png) no-repeat; background-size:100% 100%;
		border-radius: 4px;  display:flex; border-radius: 15px; border: 1px solid #EBECEE;
		box-shadow: 0px 2px 18px 0px rgba(0, 0, 0, 0.08);
		&:last-child{ border-bottom:none; margin-bottom:0;}
		.box{
			width:500px; height:290px; box-sizing: border-box; padding:55px 0 0 14px; 
			display:flex;
			.pic{ 
				width:190px; height:190px; padding:15px; margin-right:20px; box-sizing: border-box; border-radius:4px;
				&.df{ padding:0; }
				img{
					width:100%; height:100%;
				}
			}
			.info{
				flex:1; padding-top:10px;
				.name{ font-size:18px; color:#131F33; font-weight: bold; line-height:20px; margin-bottom:8px; }
				.label{ font-size: 14px; line-height:20px; color:#AEB2B9; margin-bottom:12px;}
				.des{ 
					font-size: 14px; line-height:24px; color:#AEB2B9; height:104px; margin-bottom:18px; overflow: hidden;
					overflow : hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 4; -webkit-box-orient: vertical; 
				}
				.more{ 
					display:inline-block; font-size:14px; line-height:16px; height:16px; color:#1677FF; position:relative; padding-right:16px;
					// &::after{
					// 	content:''; display:inline-block; width:10px; height:10px; 
					// 	background:url('../../static/img/ico-tri2.png') right center;  background-size: 10px 10px;
					// 	position:absolute; right:0; top:50%; margin-top:-5px;
					// }
					&:hover{ text-decoration: underline; }
				 }
			}
		}
		.course-list{
			flex:1; padding-top:24px;
			li{
				width:280px; height:246px;
				.img{ height:145px; }
			}
			li:nth-child(2){ margin-right:0;}
		}
		.more-btn{
			position:absolute; right:0; top:50%; margin-top:-77px; width:55px; height:154px; cursor: pointer;
			&:hover{ opacity: .9;}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/colleges-detail/tpl-pc.vue